import { Entitlement } from '../../types/types'

import { useState } from 'react'
import Spinner from '../Spinner'
import { NondescriptError } from '../NondescriptError'
import * as Sentry from '@sentry/nextjs'

type RequestUnlockProps =
  | Pick<Entitlement, 'hardwareId' | 'isUnlockRequested'> & {
      onClick: (hardwareId: string) => Promise<void>
    }

export const RequestUnlock = ({
  onClick,
  hardwareId,
  isUnlockRequested,
}: RequestUnlockProps) => {
  const [unlockRequested, setUnlockRequested] = useState(isUnlockRequested)
  const [loading, setLoading] = useState(false)
  const [hasError, setHasError] = useState(false)

  const requestUnlock = async () => {
    try {
      setLoading(true)
      await onClick(hardwareId)
      setUnlockRequested(true)
    } catch (err) {
      Sentry.captureException(err)
      setHasError(true)
    } finally {
      setLoading(false)
    }
  }

  if (hasError) {
    return <NondescriptError />
  }

  if (unlockRequested) {
    return <i>Remove requested - please check your email!</i>
  }

  return (
    <button className="btn btn-primary" onClick={requestUnlock}>
      {loading ? <Spinner /> : 'Request Removal'}
    </button>
  )
}
